namespace Matrix.Exceptions {
    export interface ExceptionReviewForm {
        ExceptionSource: Serenity.StringEditor;
        ExceptionContext: Serenity.StringEditor;
        ExceptionKey: Serenity.StringEditor;
        IgnorePolicyCode: Serenity.StringEditor;
        Notes: Serenity.StringEditor;
        UserTags: Serenity.StringEditor;
        AssignedTo: Serenity.StringEditor;
        AssignedWhen: Serenity.StringEditor;
        ReviewedBy: Serenity.StringEditor;
        ReviewedWhen: Serenity.StringEditor;
        IgnoredBy: Serenity.StringEditor;
        IgnoredWhen: Serenity.StringEditor;
        IgnoredUntil: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        CompletedBy: Serenity.StringEditor;
        CompletedWhen: Serenity.StringEditor;
    }

    export class ExceptionReviewForm extends Serenity.PrefixedContext {
        static formKey = 'Exceptions.ExceptionReview';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ExceptionReviewForm.init)  {
                ExceptionReviewForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(ExceptionReviewForm, [
                    'ExceptionSource', w0,
                    'ExceptionContext', w0,
                    'ExceptionKey', w0,
                    'IgnorePolicyCode', w0,
                    'Notes', w0,
                    'UserTags', w0,
                    'AssignedTo', w0,
                    'AssignedWhen', w0,
                    'ReviewedBy', w0,
                    'ReviewedWhen', w0,
                    'IgnoredBy', w0,
                    'IgnoredWhen', w0,
                    'IgnoredUntil', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'Version', w1,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'CompletedBy', w0,
                    'CompletedWhen', w0
                ]);
            }
        }
    }
}
